import ThemeProviderComponent from '@rentivo/gatsby-core/src/containers/ThemeProvider/component';

export default ThemeProviderComponent;
